import React from "react"
import { compose } from "redux"
import { connect } from "react-redux"
import { firestoreConnect } from "react-redux-firebase"

import IndexNavbar from "components/Navbars/IndexNavbar.js"
import ScheduleOrder from "components/User/ScheduleOrder.js"
import Footer from "components/Footers/Footer.js"

import { addOrder } from "actions/orderAction"
import {
  fetchPromoCode,
  incrementPromoCodeUsageCount,
} from "actions/promoCodeActions"
import {
  incrementTotalOrders,
  setMergeMerchantOrderSlots,
} from "actions/organization/usersActions"

class Schedule extends React.Component {
  render() {
    return (
      <>
        <div>
          <IndexNavbar />
          <div className="main-content">
            <ScheduleOrder
              history={this.props.history}
              merchant={this.props.merchant}
              merchantId={this.props.merchantId}
              merchantSlots={this.props.merchantSlots}
              orderDuration={this.props.orderDuration}
              selectedItems={this.props.selectedItems}
              zipCode={this.props.zipCode}
              addOrder={this.props.addOrder}
              incrementTotalOrders={this.props.incrementTotalOrders}
              setMergeMerchantOrderSlots={this.props.setMergeMerchantOrderSlots}
              fetchPromoCode={this.props.fetchPromoCode}
              incrementPromoCodeUsageCount={
                this.props.incrementPromoCodeUsageCount
              }
              promoCodeInfo={this.props.promoCodeInfo}
            />
          </div>
          <Footer />
        </div>
      </>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  let merchant = {},
    merchantSlots = {},
    orderDuration = "0",
    selectedItems = {},
    zipCode = ""
  if (ownProps && ownProps.location && ownProps.location.state) {
    if (ownProps.location.state.zipCode) {
      zipCode = ownProps.location.state.zipCode
    }
    if (
      ownProps.location.state.merchant &&
      ownProps.location.state.merchant.merchantId
    ) {
      merchant = ownProps.location.state.merchant
    }
    if (
      ownProps.location.state.selectedItems &&
      ownProps.location.state.selectedItems.vehicleType &&
      ownProps.location.state.selectedItems.package
    ) {
      selectedItems = ownProps.location.state.selectedItems
    }
    if (ownProps.location.state.orderDuration) {
      orderDuration = ownProps.location.state.orderDuration
    }
    if (
      state.firestore.ordered &&
      state.firestore.ordered.merchantSlots &&
      state.firestore.ordered.merchantSlots.length === 1
    ) {
      merchantSlots = state.firestore.ordered.merchantSlots[0]
    }
  }
  return {
    history: ownProps.history,
    merchant,
    merchantId: ownProps.match.params.merchantId,
    merchantSlots,
    orderDuration,
    selectedItems,
    zipCode,
    promoCodeInfo: { ...state.promoCode },
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addOrder: (state) => dispatch(addOrder(state)),
    incrementTotalOrders: (uid) => dispatch(incrementTotalOrders(uid)),
    setMergeMerchantOrderSlots: (data) =>
      dispatch(setMergeMerchantOrderSlots(data)),
    fetchPromoCode: (stateAndProps) => dispatch(fetchPromoCode(stateAndProps)),
    incrementPromoCodeUsageCount: (stateAndProps) =>
      dispatch(incrementPromoCodeUsageCount(stateAndProps)),
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect((props) => {
    // const docId = `${props.merchantId}-${getLocalISODateString().split('T')[0].split('-').slice(0, 2).join('-')}`
    return [
      {
        collection: `slots`,
        // doc: docId,
        doc: props.merchantId,
        storeAs: "merchantSlots",
      },
    ]
  })
)(Schedule)
